"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *
 * ### Toolbar component
 *
 *Toolbar expects children to be grouped into sections. These sections (see ButtonGroup) can be nav, div or section elements which might contain divs or buttons. Toolbar sections by default are split evenly along the toolbar.
 *
 *The facility to mix and match different sub containers within a toolbar allows for flexibility such as a toolbar with a logo, a toolbar *with different priority links or a mixture of controls (such as buttons and divs in say a `[<<][<][ 1 / 10 ][>][>>]` type paging group.)
 */
var Toolbar = function Toolbar(_ref) {
  var children = _ref.children,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'header' : _ref$element,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'between' : _ref$justify,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    element: element,
    justify: justify,
    width: width,
    role: "toolbar"
  }, children);
};

var _default = Toolbar;
exports["default"] = _default;